import { ListItemIcon, ListItemText, Menu, MenuItem, MenuProps, useTheme } from "@mui/material";
import { IContextMenuItem } from "Common/Interfaces";

interface IContextMenu extends MenuProps {
  rightOrigin?: boolean;
  handleClose: (reason?: "escapeKeyDown" | "backdropClick" | "tabKeyDown") => void;
  menuItems: IContextMenuItem[];
}

export const ContextMenu = (props: IContextMenu) => {
  const { anchorEl, open, handleClose, rightOrigin, menuItems } = props;

  const theme = useTheme();

  const getMenuItemColor = (item: IContextMenuItem) => {
    if (item.errorColor) {
      return theme.palette.error.main;
    }
    if (item.successColor) {
      return theme.palette.success.main;
    }
  };

  return (
    <Menu
      id="context-menu"
      aria-labelledby="context-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={(_, reason) => handleClose(reason)}
      anchorOrigin={{
        vertical: "top",
        horizontal: rightOrigin ? "right" : "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: rightOrigin ? "left" : "right",
      }}
    >
      {menuItems.map((item, index) => (
        <MenuItem
          key={item.event + index}
          onClick={() => {
            item.onClick?.();
          }}
          sx={(theme) => ({
            borderTop: item.hasDivider ? `1px solid ${theme.palette.divider}` : "none",
            ...(item.errorColor && {
              "& .MuiListItemIcon-root": {
                color: theme.palette.error.main,
              },
            }),
            ...(item.successColor && {
              "& .MuiListItemIcon-root": {
                color: theme.palette.success.main,
              },
            }),
          })}
          disabled={item.disabled}
        >
          {item.icon && (
            <ListItemIcon
              sx={{
                color: `${getMenuItemColor(item)} !important`,
              }}
            >
              {item.icon}
            </ListItemIcon>
          )}
          <ListItemText
            primary={item.event}
            slotProps={{
              primary: {
                sx: { color: getMenuItemColor(item) },
              },
            }}
          />
        </MenuItem>
      ))}
    </Menu>
  );
};
